import { buildUrl } from './utils';

const state = {
  links: []
};
const actions = {
  getLinks({commit, rootState: { token } }, skillId) {
    // Build your url
    const url = buildUrl([
      { 'skills': '' },
      { [`${skillId}/links`]: '' },
    ]);

    // Make GET request
    return this._vm.$http.get(url).then(({data}) => {
      // Store received data to Vuex state
      commit('setCurrentLinks', data);
      // Resolve the Promise with received data
      return Promise.resolve(data);
    });
  },
  createLink({ rootState: { token } }, { from, to, skill }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .post(url, {
        from,
        to,
        skill
      })
      .then(({ data }) => Promise.resolve(data));
  },
  updateLink({ rootState: { token } }, { old, update }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .put(url, {
        old,
        update
      })
      .then(({ data }) => Promise.resolve(data));
  },
  removeLink({ rootState: { token } }, { from, to, skill }) {
    const url = buildUrl([
      {
        links: ''
      }
    ]);
    return this._vm.$http
      .delete(url, {
        data: {
          from,
          to,
          skill
        }
      })
      .then(({ data }) => Promise.resolve(data));
  },
  duplicateLinks({ rootState: { token }}, {newNodes, uniqueLinksArray, selectedNodes}) {
    const url = buildUrl([
      {
        links: 'duplicate',
      }
    ]);
    return this._vm.$http
      .post(url, { newNodes, uniqueLinksArray, selectedNodes })
      .then(({ data }) => Promise.resolve(data));
  }
};

const mutations = {
  setCurrentLinks(state, value) {
    state.links = value;
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
};
